/**
 * Whether the app is in the middle of something a page reload would break.
 *
 * The stale-build check (components/pwa/version-check) reloads the page when
 * the server is on a newer deploy than the running bundle. A reload during a
 * live browser call drops the call; a reload between calls costs nothing. So
 * the pieces that must not be interrupted mark themselves busy here, and the
 * check waits for idle.
 */

const busy = new Set<string>();
const listeners = new Set<() => void>();

export function markBusy(key: string, on: boolean): void {
  const was = busy.size > 0;
  if (on) busy.add(key);
  else busy.delete(key);
  const is = busy.size > 0;
  if (was && !is) for (const l of listeners) l();
}

export function isBusy(): boolean {
  return busy.size > 0;
}

/** Called once the last busy key clears. Returns the unsubscribe. */
export function onIdle(fn: () => void): () => void {
  listeners.add(fn);
  return () => {
    listeners.delete(fn);
  };
}
